import { ReactNode, useState } from 'react'
import styled from 'styled-components'
import { imgLH3 } from '../../../../services/UtilService'

interface NFTCollectionBaseCardProps {
  children: ReactNode
  Link?: string
  banner_url?: string
  className?: string
}

export function NFTCollectionBaseCard({ banner_url, children, className, Link }: NFTCollectionBaseCardProps) {
  const [bannerImage, setBannerImage] = useState(banner_url)
  function handleError() {
    setBannerImage('')
  }

  return (
    <Container className={className} href={Link}>
      <ContainerImage>
        {bannerImage ? <Image src={imgLH3(bannerImage, 320, 184)} onError={() => handleError()} /> : <ImageFail />}
      </ContainerImage>
      {children}
    </Container>
  )
}
export const { Container, Image, ContainerImage, ImageFail } = {
  Container: styled.a`
    min-height: 337px;
    display: grid;
    grid-template-rows: 184px auto;
    background: ${props => props.theme.colors.gray[1]};
    border-radius: 16px;
    transition: box-shadow 0.1s;
  `,
  ContainerImage: styled.div`
    mask-image: radial-gradient(circle, white, black);
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    display: flex;
  `,
  Image: styled.img`
    width: 100%;
    height: auto;

    transition: all 0.1s ease-in-out;
    object-position: center;
    object-fit: cover;

    border-top-left-radius: 16px;
    border-top-right-radius: 16px;

    &:hover {
      transform: translateY(0px);
      transform: scale(1.1);
      filter: saturate(1.4);
    }
  `,
  ImageFail: styled.div`
    background: ${props => props.theme.colors.blue.lighter};
    opacity: 0.5;

    width: 100%;
    height: 100%;
  `
}
